export interface Testimonial {
  id: string;
  name: string;
  avatar: string;
  role: string;
  content: string;
  rating: number;
  type: 'text' | 'image';
  image?: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 't-1',
    name: '小雨同学',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20woman%20portrait%2C%20simple%20clean%20background%2C%20warm%20natural%20lighting%2C%20soft%20professional%20headshot%2C%20minimalist%20style%2C%20neutral%20cream%20background&width=120&height=120&seq=avatar-01&orientation=squarish',
    role: '忠实读者 · 3年',
    content: '从大一开始就在汗汗漫画上看韩漫了，画质超好，更新也快！最喜欢《她的心动瞬间》，每期必追！推荐给了身边所有朋友~',
    rating: 5,
    type: 'text',
  },
  {
    id: 't-2',
    name: '像素猎人',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20man%20portrait%2C%20casual%20style%2C%20simple%20clean%20background%2C%20warm%20natural%20lighting%2C%20friendly%20professional%20headshot%2C%20minimalist%20style%2C%20neutral%20cream%20background&width=120&height=120&seq=avatar-02&orientation=squarish',
    role: '漫画博主 · 50万粉丝',
    content: '作为一个漫画测评博主，我几乎用过所有漫画平台。汗汗漫画的阅读体验是顶级的，加载快、排版舒适、画质清晰，强烈推荐！',
    rating: 5,
    type: 'text',
  },
  {
    id: 't-3',
    name: '樱花落尽',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20beautiful%20woman%20portrait%2C%20elegant%20style%2C%20simple%20clean%20background%2C%20soft%20studio%20lighting%2C%20professional%20headshot%2C%20minimalist%20style%2C%20neutral%20cream%20background&width=120&height=120&seq=avatar-03&orientation=squarish',
    role: 'VIP会员',
    content: '完全免费的良心平台！分类特别详细，找漫画很方便。而且更新速度真的很快，追更体验满分！',
    rating: 5,
    type: 'image',
    image: 'https://readdy.ai/api/search-image?query=Korean%20young%20woman%20reading%20webtoon%20on%20tablet%2C%20cozy%20cafe%20setting%2C%20warm%20ambient%20lighting%2C%20relaxed%20atmosphere%2C%20minimalist%20interior%2C%20lifestyle%20photography%2C%20soft%20natural%20light&width=800&height=600&seq=testimonial-img-01&orientation=landscape',
  },
  {
    id: 't-4',
    name: '星辰大海',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20man%20portrait%2C%20professional%20look%2C%20simple%20clean%20background%2C%20studio%20lighting%2C%20friendly%20headshot%2C%20minimalist%20style%2C%20neutral%20cream%20background&width=120&height=120&seq=avatar-04&orientation=squarish',
    role: '上班族读者',
    content: '每天上下班路上必刷汗汗漫画，韩漫的画风真的太绝了。特别喜欢悬疑类的，《暗影侦探》是我今年的最爱！',
    rating: 5,
    type: 'image',
    image: 'https://readdy.ai/api/search-image?query=Korean%20man%20reading%20comic%20on%20smartphone%2C%20subway%20commute%2C%20relaxed%20casual%20atmosphere%2C%20natural%20lighting%2C%20lifestyle%20photography%2C%20modern%20urban%20setting&width=800&height=600&seq=testimonial-img-02&orientation=landscape',
  },
  {
    id: 't-5',
    name: '漫画控小鹿',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20woman%20portrait%2C%20cute%20style%2C%20simple%20clean%20background%2C%20bright%20natural%20lighting%2C%20cheerful%20headshot%2C%20minimalist%20style%2C%20neutral%20cream%20background&width=120&height=120&seq=avatar-05&orientation=squarish',
    role: '大学生读者',
    content: '汗汗漫画的内容真的太丰富了！完结漫和连载漫都有，而且分类筛选很方便。宿舍里大家都在用，已经是我们寝室的必备APP了！',
    rating: 5,
    type: 'text',
  },
];